<template>
  <div>
    <headerNav title="保证金" />

    <div class="main-div">
      <h2
        style="
          text-align: center;
          font-size: 30px;
          padding: 20px;
          border-bottom: 1px solid #eee;
          margin: 0 20px 20px 20px;
          color: #4b4b4b;
        "
      >
        {{ abp.userInfo.memberLevelModel.name }}
      </h2>
      <div
        style="
          border: 1px solid #f77b04;
          border-radius: 10px;
          width: 150px;
          text-align: center;
          margin: 0 auto;
          padding: 20px 10px;
        "
      >
        <img src="../../assets/images/earnestmoney.png" />
        <div style="margin: 10px; color: #4b4b4b; font-size: 20px; font-weight: bold">
          ￥{{ earnestMoney }}元
        </div>
        <div>保证金</div>
      </div>
      <div style="border-bottom: 1px solid #eee; margin: 20px; height: 1px"></div>
      <div style="color: #b1b1b1; margin: 20px; line-height: 0.6rem; font-size: 0.3rem">
        提交保证金是为了保市场的长远发展。如代理有出现乱价或其他违规情况,则一律按照我司规章制度处罚与扣除。如果代理因个人原因申请退出,则在非特殊况下。将于申请日起一个月后退还至个人微信账户零钱上
      </div>
      <van-form @submit="earnestreturn">
        <div style="margin: 16px">
          <p style="font-size: 16px" v-if="lastrecord.id > 0">
            审核结果:{{ lastrecord.auditStatusName }},{{ lastrecord.rejectReturnReason }}
          </p>
          <van-button
            v-if="lastrecord.id == 0 || lastrecord.auditStatus > 1"
            :color="$abctheme.basecolor"
            round
            block
            type="info"
            native-type="submit"
            >退保</van-button
          >
        </div>
      </van-form>
    </div>
    <van-dialog
      v-model="showreturn"
      title="退保申请"
      show-cancel-button
      @confirm="onSubmit"
    >
      <p style="margin: 10px; font-size: 14px">
        您确定要退保吗?退保后账号所有关系将发生变更,且无法登录使用,如无违规已缴纳的保证金将在一个月后自动打入您的微信账户
      </p>
      <van-field
        readonly
        clickable
        name="picker"
        :value="reason"
        label="退保原因"
        placeholder="点击选择原因"
        @click="showPicker = true"
      />

      <van-field v-model="suggestion" label="给公司的建议" placeholder="" />
    </van-dialog>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      earnestMoney: 0,
      wxopenid: "",
      arrow: false,
      showreturn: false,
      showPicker: false,
      columns: [
        "缺乏资金",
        "没有空闲时间",
        "做其他产品了",
        "不喜欢公司代理政策",
        "不喜欢公司管理模式",
        "其他",
      ],
      reason: "",
      suggestion: "",
      lastrecord: {}, //最后一次申请记录
    };
  },
  methods: {
    earnestreturn(){
if (!this.abp.userInfo.wxPramOpenId) {
          this.$dialog.confirm({
            title:'未绑定微信,无法申请提现',
            message:'点击确定前往微信绑定!'
          })
          .then(()=>{
            this.$router.push({
              name:'set'
            })
          })
          return;
        }
        this.showreturn = true
    },
    onSubmit() {
       
      if (!this.reason) {
        this.$toast.fail("退保原因必须选择");
        return;
      }
      this.ajax
        .post(
          "/api/services/app/PhoneUser/ApplyReturnEarnestmoney?reason=" +
            this.reason +
            "&Suggestion=" +
            this.suggestion
        )
        .then((x) => {
          this.$toast.success("申请成功,等待审核");
          location.reload();
        });
    },
    logout() {
      this.abp.auth.clearToken();
      location.reload();
    },
    onConfirm(val) {
      this.reason = val;
      this.showPicker = false;
    },
  },
  created() {
    this.earnestMoney = this.abp.userInfo.earnestMoney.toFixed(2);
    this.ajax
      .post("/api/services/app/PhoneUser/QueryMyApplyReturnEarnestmoney")
      .then((x) => {
        this.lastrecord = x.result;
      });
  },
};
</script>

<style lang="scss" scoped>
.main-div {
  background: #fff;
  border-radius: 30px;
  color: #b1b1b1;
  margin-top: 0;
}
.mian {
  position: relative;
  background-color: rgb(179, 197, 135);
  border-radius: 4px;
  box-shadow: 2px 2px 4px #bbb;
  text-align: center;
  padding: 50px 0;
  font-size: 25px;
  margin: 80px 10px 80px 10px;
}

.mian-yy {
  font-size: 100px;
}

.mian-tit {
  font-size: 28px;
}

.van-form {
  margin-left: 10px;
  margin-right: 10px;
}

.van-cell {
  border-radius: 3px;
}
</style>
